import moment from 'moment'

export default ['webskedService', 'fnService', wskTaskCardController]

function wskTaskCardController(webskedService, _fn) {
  this.$onInit = () => {
    if (window.org_settings.disableWebskedIntegration) {
      return
    }
    webskedService.getWebSkedConfig().then((cfg) => {
      let typeId = _fn.at('task.type')(this)
      let stausId = _fn.at('task.latestEvent.status')(this)
      let priorityId = _fn.at('task.latestEvent.priority')(this)
      let deadline = moment(_fn.at('task.latestEvent.deadline')(this) * 1000)
      let usr = _fn.at('task.latestEvent.assignedUser')(this)
      let grpId = _fn.at('task.latestEvent.assignedGroup')(this)
      let taskId = _fn.at('task.id')(this)

      this.disp = {
        heading: _fn.at(`taskTypes.${typeId}.name`)(cfg) || 'Task',
        priority: _fn.at(`priorities.${priorityId}.name`)(cfg) || 'Other',
        priorityClass: _fn.at(`priorities.${priorityId}.uiClass`)(cfg) || '',
        deadline: deadline.fromNow(),
        deadlineClass: deadline.isBefore(moment()) ? 'text-danger' : '',
        status: _fn.at(`taskStatuses.${stausId}.name`)(cfg) || 'unknown',
        assignee: usr || _fn.at(`groups.${grpId}.name`)(cfg),
        wskUrl: `websked/#/tasks/task/${taskId}`,
      }
    })
  }
}
